module.exports = __webpack_public_path__ + "img/こんな方-02.b194f4a9.png";